// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.employee.detailed.request.AdminCreateProviderInsuranceIdentifierRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminCreateProviderInsuranceIdentifierRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Practice Insurance Company is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceInsuranceCompanyId!: number;

	@GandalfValidator({ notNull: { message: 'Provider is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	providerId!: number;

	@GandalfConstantDecorator(constants.GroupNumberQualifier)
	@GandalfProperty({ designType: constants.GroupNumberQualifier })
	qualifier!: constants.GroupNumberQualifier | null;

	@GandalfValidator({ sizeString: { message: 'ID cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	value!: string | null;

}
